import {FactoryBankDetailsFormField} from "../types/factory-bank-details-modal.types";
import {Validators} from "@angular/forms";

export const factoryBankDetailsFormFields: Array<FactoryBankDetailsFormField> = [
  {
    fieldName: 'organizationName',
    label: 'Наименование организации',
    type: 'text',
    inputType: 'text',
    validators: [Validators.required]
  },
  {
    fieldName: 'inn',
    label: 'ИНН',
    type: 'text',
    inputType: 'number'
  },
  {
    fieldName: 'kpp',
    label: 'КПП',
    type: 'text',
    inputType: 'number'
  },
  {
    fieldName: 'bic',
    label: 'БИК',
    type: 'text',
    inputType: 'number'
  },
  {
    fieldName: 'bankName',
    label: 'Наименование банка',
    type: 'text',
    inputType: 'text'
  },
  {
    fieldName: 'settlementAccount',
    label: 'Расчетный счет',
    type: 'text',
    inputType: 'text'
  },
  {
    fieldName: 'correspondentAccountNumber',
    label: 'Корреспондентский счёт',
    type: 'text',
    inputType: 'text'
  },
  {
    fieldName: 'ogrn',
    label: 'ОГРН (ОГРНИП)',
    type: 'text',
    inputType: 'text'
  },
  {
    fieldName: 'legalAddress',
    label: 'Юридический адрес',
    type: 'text',
    inputType: 'text'
  },
  {
    fieldName: 'actualAddress',
    label: 'Фактический адрес',
    type: 'text',
    inputType: 'text'
  },
  {
    fieldName: 'email',
    label: 'Почта',
    type: 'email',
    inputType: 'email',
    validators: [ Validators.email ]
  },
  {
    fieldName: 'phoneNumber',
    label: 'Телефон',
    type: 'tel',
    inputType: 'tel'
  },
  {
    fieldName: 'comment',
    label: 'Комментарий',
    type: 'textarea',
    inputType: 'text'
  }
]
